module.exports = __webpack_public_path__ + "static/media/export_animated.79d7890f.gif";